import { render, staticRenderFns } from "./customer-care.vue?vue&type=template&id=6b99d304&"
import script from "./customer-care.vue?vue&type=script&lang=js&"
export * from "./customer-care.vue?vue&type=script&lang=js&"
import style0 from "./customer-care.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports